// https://github.com/glidejs/glide

/**
 * Glide has options for prev and next buttons
 * The slides are scaled relative to the Glide instance element
 * So positioning the prev/next buttons next to it, makes them overlap the slides
 */

import Glide from '@glidejs/glide';
import debounce from 'lodash-es/debounce';

import Base from './base';

class Carousel extends Base {
	start() {
		this.numSlides = this.queryAll('.js-slide').length;

		if (this.numSlides === 0) {
			return;
		}

		this.onResize = debounce(this.onResize, 250);

		this.createGlider();
		this.updateButtonStates();

		this.on('resize', window);
		this.on('click');
	}

	parseBreakpoints(breakpoints) {
		const defaults = {
			900: { perView: 2 },
			400: { perView: 1 },
		};

		try {
			return breakpoints ? JSON.parse(breakpoints) : defaults;
		} catch (e) {
			console.error('Failed to parse carousel breakpoints:', e);

			return defaults;
		}
	}

	createGlider() {
		const defaultPerView = 4;
		const carouselEl = this.refs.slider.closest('.carousel');
		const perView = parseInt(carouselEl?.dataset?.perView, 10) || defaultPerView;
		const breakpoints = this.parseBreakpoints(carouselEl?.dataset?.breakpoints);

		this.glide = new Glide(this.refs.slider, {
			// using `carousel` causes problems with rendering of Highcharts
			type: 'slider',
			bound: true,
			rewind: false,
			animationDuration: 250,
			startAt: 0,
			perView,
			breakpoints,
		});

		this.glide.mount();
		this.glide.on('run', () => this.onGlided());
	}

	onClick(e) {
		const { target } = e;

		if (target === this.refs.buttonNext) {
			this.glide.go('>');
		} else if (target === this.refs.buttonPrev) {
			this.glide.go('<');
		}
	}

	onResize() {
		this.updateButtonStates();
	}

	onGlided() {
		this.updateButtonStates();
	}

	updateButtonStates() {
		const {
			index,
			settings: { perView },
		} = this.glide;

		const isBegin = index === 0;
		const isEnd = perView + index >= this.numSlides;
		const hasMultiplePages = this.numSlides > perView;

		this.refs.buttonPrev.disabled = !hasMultiplePages || isBegin;
		this.refs.buttonNext.disabled = !hasMultiplePages || isEnd;
	}
}

export default Carousel;
